import React, { useState } from "react";
import { useHistory } from "react-router";
import {
  Divider,
  Flex,
  Grid,
  Headline,
  Icon,
  Type,
  Utility,
} from "mesh-component-library";
import { CloseIcon } from "mesh-icon-library";
import { AddVehicleByMakeModel } from "./AddVehicleByMakeModel";
import Spinner from "../../components/spinner";
import { useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { generatePath } from "../../utilities/RedirectUtils";
import { AddVehicleByLicensePlateVin } from "./AddVehicleByLicensePlateVin";

type AddVehicleProps = {
  isAddVehicleByPlateVinFlow: boolean;
};

export const AddVehicle = ({ isAddVehicleByPlateVinFlow }: AddVehicleProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const getTranslatedText = useLocale();
  const history = useHistory();

  const handleCloseClick = () => {
    history.push(generatePath("location"));
  };

  return (
    <Utility.Div data-dd-privacy="allow">
      {isLoading && <Spinner />}
      <Grid
        id="addVehicleScreen"
        utils={{
          hrLeft: "md",
          hrRight: "md",
          vrTop: "md",
        }}
        verticalAlign="middle"
      >
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          {/* Start of "Header" portion */}
          <Grid.Column>
            <Flex alignItems="stretch" justifyContent="center" isBlock={true}>
              <Headline
                title={
                  <Type
                    variant="brand"
                    align="left"
                    size="3xl"
                    weight="semibold"
                    lineHeight="md"
                    data-testid="add-vehicle-title"
                  >
                    {getTranslatedText(TRANSLATION_CONSTANTS.VEHICLE_INFO)}
                  </Type>
                }
              />
              <Utility.Div
                onClick={handleCloseClick}
                data-testid="add-vehicle-close-icon"
              >
                <Icon icon={CloseIcon} size={1.75} />
              </Utility.Div>
            </Flex>
          </Grid.Column>
          <Divider thickness="thick" utils={{ vrBottom: "md" }} />
          {/* End of "Header" portion */}
          {/* Display vehicle selection components based on partner requirements */}
          {isAddVehicleByPlateVinFlow ? (
            <AddVehicleByLicensePlateVin />
          ) : (
            <AddVehicleByMakeModel setIsLoading={setIsLoading} />
          )}
        </Grid.Column>
      </Grid>
    </Utility.Div>
  );
};
